import AOS from "aos";
import lozad from "lozad";
import {
	setBackgroundElement,
	detectCloseElement,
	buttonToTop,
	clickScrollToDiv,
	appendCaptchaASP,
} from "./helper";
import { header } from "./header";
import swiperInit from "./swiper";
$(document).ready(function () {
	setBackgroundElement();
	header.init();
	swiperInit();
	cuisineDetail();
	clickChangeIframe();
	appendCaptchaASP();
	calPositionCuisine();
	scrollToSectionProduct();
});
/*==================== Click Scroll To Div ====================*/
function scrollToSectionProduct() {
	if (!$(".section-product-list-sub").length) return;
	var url = new URL(window.location.href);
	var path = url.pathname + url.search + url.hash;
	const nodeEleSelect = $(`.product-list-wrap-sub[data-url="${path}"]`);
	$("html, body").animate(
		{
			scrollTop: nodeEleSelect.offset().top - $('header').outerHeight(),
		},
		800
	);
}
/*==================== Calculate position cuisine ====================*/
function calPositionCuisine() {
	if (!$(".section-cuisine-2").length) return;
	$(".section-cuisine-2 .item-ingredient")
		.filter(function (index) {
			const number = index + 1;
			return (
				(number % 2 == 0 && (number / 2) % 2 == 0) ||
				(number % 2 == 1 && ((number - 1) / 2) % 2 == 1)
			);
		})
		.addClass("reflect");
}
/*==================== Page Contact ====================*/
function clickChangeIframe() {
	$(".item-location a").on("click", function () {
		let linkMap = $(this).attr("data-iframe");
		$(".map-location iframe").attr("src", linkMap);
		$(this).closest('.item-location').toggleClass('active').siblings().removeClass('active')
		return false;
	});
}

/*==================== Cuisine Detail ====================*/
function cuisineDetail() {
	if (!$(".section-cuisine-3").length) return;
	let heightItem = $(".section-cuisine-3 .wrap-item-step .img").height();
	$(".section-cuisine-3 .wrap-main")
		.get(0)
		.style.setProperty("--height", heightItem + "px");
	console.log("🚀 ~ file: main.js:16 ~ cuisineDetail ~ heightItem:", heightItem);
}
/*==================== Aos Init ====================*/
AOS.init({
	offset: 100,
});
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
